export default __webpack_public_path__ + "static/media/1-2-17-019-Animal-Friends-3.ddc2fbab.png";